import { makeReducer } from '../utils/redux.tools';
import { I18nActions } from '../actions/i18n.actions';

export const initialState = {
    i18n: true
};

const i18nRed = {
    [I18nActions.FETCH_I18N]: (state, payload) => ({ ...state, ...payload }),
    [I18nActions.SET_I18N]: (state, payload) => ({ ...state, i18n: payload })
};
export const i18nReducer = makeReducer('Alerts', initialState, i18nRed);
